import React from 'react';
import './TopReasonsChart.scss';
import { FunnelReason } from '../../interfaces/panel-data';

interface TopReasonsChartProps {
  title: string;
  reasons: FunnelReason[];
}

export const TopReasonsChart: React.FC<TopReasonsChartProps> = ({ title, reasons }) => {
  if (!reasons || reasons.length === 0) return null;
  const maxCount = Math.max(...reasons.map((r) => r.count));

  return (
    <div className="ovp-reasons">
      <div className="ovp-reasons__title">{title}</div>
      {/* Keyed on sub-stage and reason both, since the same reason can be recorded against several
          sub-stages — keying on the reason alone gives React duplicate keys. */}
      {reasons.map((r) => (
        <div key={`${r.subStage}-${r.reason}`} className="ovp-reasons__row">
          <span className="ovp-reasons__label">
            {r.reason} <small className="ovp-reasons__sub">({r.subStage})</small>
          </span>
          <div className="ovp-reasons__track">
            <span
              className="ovp-reasons__fill"
              // maxCount is 0 when every reason has a zero count; dividing would give width: NaN%,
              // which silently renders nothing at all.
              style={{ width: `${maxCount > 0 ? (r.count / maxCount) * 100 : 0}%` }}
            />
          </div>
          <span className="ovp-reasons__count">{r.count.toLocaleString()}</span>
        </div>
      ))}
    </div>
  );
};
